interface ProcessingStatusProps {
  progress: number;
  status: string;
  currentBatch?: number;
  totalBatches?: number;
}

export default function ProcessingStatus({ progress, status, currentBatch, totalBatches }: ProcessingStatusProps) {
  return (
    <div className="progress-section">
      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${progress}%` }}>
          {progress > 0 && `${Math.round(progress)}%`}
        </div>
      </div>
      <div className="progress-status">
        <div className="loading-spinner"></div>
        <div>
          {status}
          {currentBatch && totalBatches && (
            <div style={{ fontSize: '0.9rem', color: '#666', marginTop: '5px' }}>
              Batch {currentBatch} of {totalBatches}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}


